import React, { Suspense, lazy } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Provider } from 'react-redux'
import 'format-unicorn'

import history from './history'
import { store } from './redux/store'

import 'react-loading-skeleton/dist/skeleton.css'

import Layout from './components/Containers/Layout/Layout'
import AuthLayout from './components/Containers/AuthLayout/AuthLayout'
import OrganizationLayout from './components/Containers/OrganizationLayout/OrganizationLayout'
import PageLoader from './components/UI/PageLoader/PageLoader'

/* moment */
import moment from 'moment-timezone'
import 'moment/locale/it'
moment.tz.setDefault('Europe/London')

const HomeLazy = lazy(() => import('./components/Pages/Home/Home'))
const NotFoundLazy = lazy(() => import('./components/Pages/NotFound/NotFound'))
const OrganizationsLazy = lazy(() =>
  import('./components/Pages/Organizations/Organizations')
)
const OrganizationEditorLazy = lazy(() =>
  import('./components/Pages/OrganizationEditor/OrganizationEditor')
)
const DashboardLazy = lazy(() =>
  import('./components/Pages/Dashboard/Dashboard')
)
const AudiencesLazy = lazy(() =>
  import('./components/Pages/Audiences/Audiences')
)
const CampaignsLazy = lazy(() =>
  import('./components/Pages/Campaigns/Campaigns')
)
const AccountsLazy = lazy(() => import('./components/Pages/Accounts/Accounts'))
const AccountEditorLazy = lazy(() =>
  import('./components/Pages/AccountEditor/AccountEditor')
)
const AudienceEditorLazy = lazy(() =>
  import('./components/Pages/AudienceEditor/AudienceEditor')
)
const CampaignEditorLazy = lazy(() =>
  import('./components/Pages/CampaignEditor/CampaignEditor')
)
const TemplateLazy = lazy(() =>
  import('./components/Pages/Templates/Templates')
)
const TemplateEditorLazy = lazy(() =>
  import('./components/Pages/TemplateEditor/TemplateEditor')
)
const SettingsLazy = lazy(() => import('./components/Pages/Settings/Settings'))

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<HomeLazy />} />
              <Route element={<AuthLayout />}>
                <Route path='settings' element={<SettingsLazy />} />
                <Route path='organizations' element={<OrganizationsLazy />} />
                <Route
                  path='organizations/:id'
                  element={<OrganizationEditorLazy />}
                />

                <Route path=':orgId' element={<OrganizationLayout />}>
                  <Route path='dashboard' element={<DashboardLazy />} />
                  <Route path='audiences' element={<AudiencesLazy />} />
                  <Route
                    path='audiences/:id'
                    element={<AudienceEditorLazy />}
                  />
                  <Route path='campaigns' element={<CampaignsLazy />} />
                  <Route
                    path='campaigns/:id'
                    element={<CampaignEditorLazy />}
                  />
                  <Route path='templates' element={<TemplateLazy />} />
                  <Route
                    path='templates/:id'
                    element={<TemplateEditorLazy />}
                  />
                  <Route path='accounts' element={<AccountsLazy />} />
                  <Route path='accounts/:id' element={<AccountEditorLazy />} />
                  <Route path='settings' element={<OrganizationEditorLazy />} />
                </Route>
              </Route>
              <Route path='*' element={<NotFoundLazy history={history} />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </Provider>
  )
}

export default App
